import React, { useState, useRef, useEffect } from "react";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Fieldset } from "primereact/fieldset";
import { Panel } from 'primereact/panel';
import axios from "axios";
import { Dropdown } from "primereact/dropdown";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { Message } from "primereact/message";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { InputMask } from "primereact/inputmask";
import { Steps } from "primereact/steps";


const ModuleReservationAdd = props => {
    const toast = useRef(null);
    const [moduleList, setModuleList] = useState([]);
    const [modulID, setModulID] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [finishDate, setFinishDate] = useState(new Date());
    const [minRezDate, setMinRezDate] = useState(new Date());
    const [resvStartTime, setResvStartTime] = useState(null);
    const [resvFinishTime, setResvFinishTime] = useState(null);
    const [umdReservationReason, setUmdReservationReason] = useState(null);
    const [paramID, setParamID] = useState(null);
    const [maxRez, setMaxRez] = useState(0);
    const [roleValue, setRoleValue] = useState(null);
    const [isRegistration, setIsRegistration] = useState(null);
    const [roleList, setRoleList] = useState([]);
    const [numberTempDisplay, setNumberTempDisplay] = useState("block");
    const [userTypeTempDisplay, setUserTypeTempDisplay] = useState("none");
    const [workStatusTempDisplay, setWorkStatusTempDisplay] = useState("none");
    const [number, setNumber] = useState(null);
    const [userType, setUserType] = useState(null);
    const [workStatus, setWorkStatus] = useState(null);

    const [activeIndex, setActiveIndex] = useState(0);
    const interactiveItems = [
        {
            label: 'Telefon Numarası',
            command: (event) => {
                setStepTemplate("number");
            }
        },
        {
            label: 'Kullanıcı Tipi',
            command: (event) => {
                setStepTemplate("userType");
            }
        },
        {
            label: 'Çalışma Durumu',
            command: (event) => {
                setStepTemplate("workStatus");
            }
        },

    ];


    const setStepTemplate = (state) => {
        setNumberTempDisplay("none");
        setUserTypeTempDisplay("none");
        setWorkStatusTempDisplay("none");

        if (state == "number") {
            setNumberTempDisplay("block")
        } else if (state == "userType") {
            setUserTypeTempDisplay("block")
        } else if (state == "workStatus") {
            setWorkStatusTempDisplay("block")
        } else if (state == "education") {
        }
    }


    const showSuccess = (message) => {
        toast.current.show({ severity: 'success', summary: message, life: 5000 });
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 5000
        });
    }

    useEffect(() => {
        resultMaxRez();
        getModuleList();
        startDate.setDate(startDate.getDate() + 1);
        finishDate.setDate(finishDate.getDate() + 1);
        let searchURL = props.location.search;
        const params = new URLSearchParams(searchURL);
        const param_module_id = parseInt(params.get('module_id'));
        setParamID(param_module_id)
        setModulID(param_module_id)
        if (param_module_id) {
            getUserRoleList(param_module_id)
        }
    }
        ,
        []
    )
        ;

    const ModuleOptionItems = moduleList.slice(-3).map((item) => (
        { "label": item.md_name, "value": item.md_id }
    ))

    const ModuleOptionItems2 = roleList.length > 0 ?
        roleList.map((item) => (
            { "label": item.rolg_name, "value": item.rolg_id }
        )) : [];

    const getUserRoleList = (param_id) => {
        setModulID(param_id)
        const token = localStorage.getItem("token");
        const headers = { "Authorization": "Token " + token }
        axios.get('/api/md-roles/' + `${param_id}/`, { "headers": headers })
            .then(res => {
                setRoleList(res.data.user_role_list)
            })

            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return { status: res.status, data };
                    })
                } else {
                    throw res;
                }
            })

            .then(res => {

                if (res.status === 401) {
                    props.loadUser();
                    throw res.data;
                } else if (res.status === 403) {
                    throw res.data;
                }
            })
    }

    const getModuleList = () => {


        const token = localStorage.getItem("token");
        const headers = { "Authorization": "Token " + token }
        axios.get('/api/content/module/list/', { "headers": headers })
            .then(res => {
                const data = res.data
                setModuleList(data)
            })

    }

    const resultMaxRez = () => {
        const token = localStorage.getItem("token");
        const headers = { "Authorization": "Token " + token }
        axios.get('/api/max-rez-time/', { "headers": headers })
            .then(res => {
                let limit = res.data.result
                setMaxRez(limit['maxModülRezTime'])
            })
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return { status: res.status, data };
                    })
                } else {
                    throw res;
                }
            })

            .then(res => {

                if (res.status === 401) {
                    props.loadUser();
                    throw res.data;
                } else if (res.status === 403) {
                    throw res.data;
                }
            })
    }

    const onChangeStartDate = (value) => {
        const date = new Date();
        var year = value.getFullYear();
        var month = value.getMonth();
        var day = value.getDate();

        // Seçilen tarihe 1 gün ekle
        var nextDay = new Date(year, month, day + 1);

        // Ay ve yıl sınırlarını kontrol et
        if (nextDay.getMonth() !== month) {
            // Ay sınırını aştığında, bir sonraki ayın ilk gününü ayarla
            nextDay = new Date(year, month + 1, 1);
        }
        if (nextDay.getFullYear() !== year) {
            // Yıl sınırını aştığında, bir sonraki yılın ilk ayının ilk gününü ayarla
            nextDay = new Date(year + 1, 0, 1);
        }
        setMinRezDate(nextDay)
        var date2 = new Date(value);
        date.setMonth(date2.getMonth() + maxRez);

        setFinishDate(date);
        setResvStartTime(value);
    }

    const submit = () => {
        let module_name = "";
        ModuleOptionItems.map((val) => {
            if (val.value === modulID) {
                module_name = val.label;
            }
        });


        if (modulID === 4) {
            if (modulID === null || module_name === null || umdReservationReason === null || number === null || userType === null
                || workStatus === null) {
                showError("Lütfen istenen tüm bilgileri giriniz!");
            } else {
                var vk_obj = {
                    umd_reservation_reason: umdReservationReason,
                    select_role: [userType]
                }
                var obj = {
                    md_id: modulID,
                    md_name: module_name,
                    umd_starttime: resvStartTime,
                    umd_finishtime: resvFinishTime,
                    number: number,
                    workStatus: workStatus,
                    job_and_reason: vk_obj
                };
                let headers = { "Content-Type": "application/json" };
                let token = localStorage.getItem("token");

                if (token) {
                    headers["Authorization"] = `Token ${token}`;
                    const body = JSON.stringify(obj);
                    fetch("/api/md_usermodules_add/", { headers, method: "POST", body })
                        .then(res => {
                            if (res.status < 500) {

                                return res.json().then(data => {
                                    return { status: res.status, data };
                                })
                            } else {
                                throw res;
                            }
                        })
                        .then(res => {
                            if (res.status === 200) {

                                const data = res.data;
                                if (data.result) {
                                    window.location.hash = "/my-md-reservations"
                                    showSuccess(data.message);
                                    // setData(data.result)
                                } else {
                                    showError(data.message);
                                    // this.setState({disable_submit_btn: false});
                                }
                            } else if (res.status === 401) {
                                props.loadUser();
                                throw res.data;

                            } else if (res.status === 403) {
                                throw res.data;

                            }
                        })

                }

                setModulID('')
                setResvFinishTime('')
                setResvStartTime('')
                setUmdReservationReason('')
                setRoleValue('')
            }


        } else {

            if (modulID === null || module_name === null || resvStartTime === null || resvFinishTime === null || umdReservationReason === null) {
                showError("Lütfen istenen tüm bilgileri giriniz!");
            } else {
                var reason_obj = {
                    umd_reservation_reason: umdReservationReason,
                    select_role: roleValue
                }
                var obj = {
                    md_id: modulID,
                    md_name: module_name,
                    umd_starttime: resvStartTime,
                    umd_finishtime: resvFinishTime,
                    job_and_reason: reason_obj

                };
                let headers = { "Content-Type": "application/json" };
                let token = localStorage.getItem("token");

                if (token) {
                    headers["Authorization"] = `Token ${token}`;
                    const body = JSON.stringify(obj);
                    fetch("/api/md_usermodules_add/", { headers, method: "POST", body })
                        .then(res => {
                            if (res.status < 500) {

                                return res.json().then(data => {
                                    return { status: res.status, data };
                                })
                            } else {
                                throw res;
                            }
                        })
                        .then(res => {
                            if (res.status === 200) {

                                const data = res.data;
                                if (data.result) {
                                    window.location.hash = "/my-md-reservations"
                                    showSuccess(data.message);
                                    // setData(data.result)
                                } else {
                                    showError(data.message);
                                    // this.setState({disable_submit_btn: false});
                                }
                            } else if (res.status === 401) {
                                props.loadUser();
                                throw res.data;

                            } else if (res.status === 403) {
                                throw res.data;

                            }
                        })

                }

                setModulID('')
                setResvFinishTime('')
                setResvStartTime('')
                setUmdReservationReason('')
                setRoleValue('')
            }


        }
    }

    return (
        <div className="p-fluid" style={{ fontSize: 'large' }}>
            <Toast ref={toast} />

            <Panel>

                <div className="p-grid">
                    <div className="p-col-10 p-md-offset-1" align="center">
                        <Fieldset legend="Portal Kullanım Başvuru Formu"
                            style={{ fontFamily: 'sans-serif' }}>
                            <div className="p-col-12 p-md-12">

                                <Fieldset legend="Modül Seçimi" toggleable>
                                    <div className="p-col-12 p-md-12">
                                        {paramID === 4
                                            ?
                                            <Dropdown
                                                options={ModuleOptionItems}
                                                onChange={(e) => setModulID(4)}
                                                value={modulID}
                                                showClear={true}
                                                required={true}
                                                placeholder="Modül Seçiniz"
                                                emptyMessage="Kayıt Bulunamadı"

                                            />
                                            :
                                            null

                                        }
                                        {paramID === 5
                                            ?
                                            <Dropdown
                                                options={ModuleOptionItems}

                                                onChange={(e) => setModulID(5)}
                                                value={modulID}
                                                showClear={true}
                                                required={true}
                                                disabled
                                                placeholder="Değirmen Portali"
                                                emptyMessage="Kayıt Bulunamadı"

                                            />
                                            :
                                            null
                                        }
                                        {paramID === 6
                                            ?
                                            <Dropdown
                                                options={ModuleOptionItems}
                                                onChange={(e) => setModulID(6)}
                                                value={modulID}
                                                showClear={true}
                                                required={true}
                                                disabled
                                                placeholder="Model Eğitim Portali"
                                                emptyMessage="Kayıt Bulunamadı"

                                            />


                                            :
                                            null
                                        }
                                        {paramID === 13
                                            ?
                                            <Dropdown
                                                options={ModuleOptionItems}
                                                onChange={() => setModulID(13)}
                                                value={modulID}
                                                showClear={true}
                                                required={true}
                                                disabled
                                                placeholder="Eğitim Portali"
                                                emptyMessage="Kayıt Bulunamadı"
                                            />
                                            :
                                            null
                                        }
                                        {paramID === 14
                                            ?
                                            <Dropdown
                                                options={ModuleOptionItems}
                                                onChange={() => setModulID(14)}
                                                value={modulID}
                                                showClear={true}
                                                required={true}
                                                disabled
                                                placeholder="Simülasyon Portali"
                                                emptyMessage="Kayıt Bulunamadı"
                                            />
                                            :
                                            null
                                        }
                                        {paramID === 15
                                            ?
                                            <Dropdown
                                                options={ModuleOptionItems}
                                                onChange={(e) => setModulID(15)}
                                                value={modulID}
                                                showClear={true}
                                                required={true}
                                                disabled
                                                placeholder="Kıyasla Portali"
                                                emptyMessage="Kayıt Bulunamadı"
                                            />
                                            :
                                            null
                                        }
                                        {paramID === 6 || paramID === 4 || paramID === 5 || paramID === 13 || paramID === 14 || paramID === 15 ?
                                            null :
                                            <Dropdown
                                                options={ModuleOptionItems}
                                                onChange={(e) => getUserRoleList(e.target.value)}
                                                value={modulID}
                                                showClear={true}
                                                required={true}
                                                placeholder="Modül Seçiniz"
                                                emptyMessage="Kayıt Bulunamadı"

                                            />
                                        }


                                    </div>

                                </Fieldset>
                            </div>

                            <div className="p-mt-4">

                                <Fieldset legend="Portal Kullanım Amacı" toggleable>

                                    <div className="p-col-12 p-md-12">
                                        <InputTextarea value={umdReservationReason}
                                            onChange={(e) => setUmdReservationReason(e.target.value)}
                                            rows={5} cols={30} />

                                    </div>
                                    <Message severity="info"
                                        text="Bu alana portal kullanım amacı girilmelidir." />
                                </Fieldset>
                            </div>
                            {modulID === 4
                                ?
                                null
                                :
                                <div className="p-mt-4">

                                    <Fieldset legend="Rol Seçimi" toggleable>
                                        <div className="p-col-12 p-md-12">

                                            <MultiSelect value={roleValue}
                                                options={ModuleOptionItems2}
                                                onChange={(e) => setRoleValue(e.value)}
                                                optionLabel="label"
                                                placeholder="Rol Gruplarını Seçiniz"
                                                display="chip" />

                                        </div>
                                        <Message severity="info"
                                            text="Bu alanda portal kullanım amacınıza uygun olan rol grubunuzu seçiniz." />

                                    </Fieldset>

                                    </div>
                                }




                                    {modulID === 4
                                        ?
                                        null
                                        :

                                        <div className="p-mt-4">

                                            <Fieldset legend="Başlangıç Tarihi" toggleable>

                                                <div className="p-col-12 p-md-12">
                                                    <Calendar
                                                        minDate={startDate}
                                                        showIcon
                                                        placeholder="Başlangıç Tarihi"
                                                        hideOnDateTimeSelect={true}
                                                        dateFormat="dd/mm/yy"
                                                        locale="tr"
                                                        id="time24"
                                                        value={resvStartTime}
                                                        onChange={(e) => onChangeStartDate(e.value)}
                                                    />
                                                </div>

                                            </Fieldset>
                                        </div>
                                    }
                                    
                                    {modulID === 4
                                        ?
                                        null
                                        :
                                        <div className="p-mt-4">
                                            <Fieldset legend="Bitiş Tarihi" toggleable>

                                                <div className="p-col-12 p-md-12">
                                                    <Calendar
                                                        minDate={minRezDate}
                                                        maxDate={finishDate}
                                                        showIcon
                                                        placeholder="Bitiş Tarihi"
                                                        hideOnDateTimeSelect={true}
                                                        dateFormat="dd/mm/yy"
                                                        locale="tr"
                                                        id="time24"
                                                        value={resvFinishTime}
                                                        onChange={(e) => setResvFinishTime(e.value)}
                                                    />
                                                </div>

                                            </Fieldset>

                                        </div>
                                    }
                                    {modulID === 4 ?
                                        <div className="p-mt-4">
                                            <Fieldset legend="Kullanıcı Bilgileri" toggleable>
                                                <div className="p-col-12 p-md-12 p-lg-12 p-xl-12">
                                                    <Steps model={interactiveItems} activeIndex={activeIndex}
                                                        onSelect={(e) => setActiveIndex(e.index)}
                                                        readOnly={false} />
                                                </div>

                                                <div className="p-col-12 p-md-12 p-lg-12 p-xl-12" align="center">

                                                    {/*Telefon Numarası*/}
                                                    <div style={{ display: numberTempDisplay }}>
                                                        <h2>Telefon Numarası</h2>

                                                        <InputMask
                                                            id="phone"
                                                            mask="(999) 999-9999"
                                                            value={number}
                                                            placeholder="(999) 999-9999"
                                                            onChange={(e) => setNumber(e.value)} />
                                                    </div>

                                                    <div style={{ display: userTypeTempDisplay }}>
                                                        <h2>Kullanıcı Tipi</h2>

                                                        <div className="p-field-radiobutton"
                                                            style={{ display: 'table-cell' }}>
                                                            {isRegistration ?
                                                                <div>
                                                                    <RadioButton inputId="userType1" name="userType"
                                                                        value="annotate"
                                                                        disabled={isRegistration}
                                                                        onChange={(e) => setUserType(e.value)}
                                                                        checked={userType === 'annotate'} /> &
                                                                    nbsp;
                                                                    <label htmlFor="userType1">Aday
                                                                        Etiketleyici</label>&nbsp; &nbsp;
                                                                </div>
                                                                :
                                                                null
                                                            }


                                                            <RadioButton inputId="userType2" name="userType"
                                                                value="annotations"
                                                                onChange={(e) => setUserType(e.value)}
                                                                checked={userType === 'annotations'} />&nbsp;
                                                            <label htmlFor="userType2">Veri Seti Sağlayıcısı</label>
                                                        </div>
                                                    </div>

                                                    <div style={{ display: workStatusTempDisplay }}>
                                                        <h2>Çalışma Durumu</h2>

                                                        <div className="p-field-radiobutton"
                                                            style={{ display: 'inline' }}>
                                                            <RadioButton inputId="workStatus1" name="userType"
                                                                value="student"
                                                                onChange={(e) => setWorkStatus(e.value)}
                                                                checked={workStatus === 'student'} />&nbsp;
                                                            <label
                                                                htmlFor="workStatus1">Öğrenci</label>&nbsp; &nbsp;

                                                            <RadioButton inputId="workStatus2" name="userType"
                                                                value="graduate"
                                                                onChange={(e) => setWorkStatus(e.value)}
                                                                checked={workStatus === 'graduate'} />&nbsp;
                                                            <label htmlFor="workStatus2">Mezun</label>&nbsp; &nbsp;

                                                            <RadioButton inputId="workStatus3" name="userType"
                                                                value="worker"
                                                                onChange={(e) => setWorkStatus(e.value)}
                                                                checked={workStatus === 'worker'} />&nbsp;
                                                            <label
                                                                htmlFor="workStatus3">Çalışan</label>&nbsp; &nbsp;
                                                        </div>
                                                    </div>

                                                    {/*<div style={{display: educationTempDisplay}}>*/}
                                                    {/*    <h2>Eğitim</h2>*/}
                                                    {/*    <div className="grid">*/}
                                                    {/*        <div className="p-col-12 p-md-12 p-lg-12 p-xl-12">*/}
                                                    {/*            <Dropdown value={education} options={educationTypes}*/}
                                                    {/*                      onChange={(e) => setEducation(e.value)}*/}
                                                    {/*                      optionLabel="name"*/}
                                                    {/*                      placeholder="Eğitim Durumu Seçiniz.."/>*/}
                                                    {/*        </div>*/}
                                                    {/*        <div className="p-col-12 p-md-12 p-lg-12 p-xl-12">*/}
                                                    {/*            <InputText value={school}*/}
                                                    {/*                       onChange={(e) => setSchool(e.target.value)}*/}
                                                    {/*                       placeholder="Okul Adı Giriniz.."/>*/}
                                                    {/*        </div>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                </div>
                                            </Fieldset>
                                        </div>
                                        :
                                        null
                                    }

                        </Fieldset>


                    </div>


                </div>
                <div className="p-col-12 p-md-12" align="center">
                    <div className="p-mt-2">
                        <Button label="Başvuru Yap" icon="pi pi-check" className="p-button-secondary"
                            onClick={submit}
                            style={{ height: '40px', width: '15%' }} />
                    </div>
                </div>

            </Panel>
        </div>
    )


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps,
    mapDispatchToProps)(ModuleReservationAdd);


// WEBPACK FOOTER //
// ./src/pages/modulemanagement/ModuleReservationAdd.jsx